import { localize } from '../helpers';

export const templates = (translations: Record<string, string>, module: string) => {
    const data = {
        findNdsPayer: {
            nameServices: localize('find-nds-payer-service-search-vat-data', translations) + ':',
            link: '<div>[portal-host]/services/isnaportalsync/public/search-payer-data,</div> <div>[portal-host]/services/isnaportalsync/public/check-certificate-number-and-series-for-compliance</div>',
            method: 'GET',
            params: '<div>taxpayerCode: <ИИН/БИН></div>' +
                '<div>number: <Номер свидетельства></div>' +
                '<div>series: <Серия свидетельства></div>',
            resultExample:
`{
    "iinBin": "string",
    "nameRu": "string",
    "nameEn": "string",
    "nameKz": "string",
    "ndsRegistrationDate": "string",
    "ndsDeregistrationDate": "string",
    "ndsDeregistrationReason": "string" 
}`
        },
        ServiceUnreliableTaxpayers: {
            nameServices: 'Поиск неблагонадежных НП:',
            link: '[portal-host]/services/isnaportal/public/taxpayer-data/search',
            method: 'POST',
            params: `-`,
            titleBody: 'Тело запроса: JSON-объект вида:',
            requestBody:
`{
    "iinBin": "string",
    "number": "string",
    "rnn": "string",
    "series": "string",
    "type": "SEARCH"
}`,
            resultExample:
`{
    "name": "name", 
    "iinBin": "iinBin", 
    "rnn": null, 
    "beginDate": null, 
    "endDate": null, 
    "reason": null, 
    "certificateInfo": null
}`,
        },
        FindTaxpayerService: [
            {
            nameServices: localize('api-search-tp', translations),
            link: '[portal-host]/services/isnaportalsync/open-api/taxpayer-data',
            method: 'GET',
            paramsTitle: 'Физическое лицо:',
            params: '<div>taxpayerCode: <ИИН></div>' +
                '<div>taxpayerType: FL</div>',
                resultExample:
`{
  "taxpayerPortalSearchResponses": [
    {
      "responseMessageUid": "string",
      "messageResult": "string",
      "errorMessage": "string",
      "code": "string",
      "taxpayerType": "string",
      "fullName": {
        "lastName": "string",
        "firstName": "string",
        "middleName": "string"
      },
      "registrationType": {
        "code": "string",
        "ru": "string",
        "kk": "string",
        "en": "string",
        "qq": "string"
      },
      "beginDate": "string",
      "endDate": "string",
      "endReasonCode": "string",
      "additionalInfo": "string",
      "taxOrg": "string"
    }
  ]
}`
            },
            {
                paramsTitle: 'Индивидуальный предприниматель:',
                params: '<div>taxpayerCode: <ИИН/БИН></div>' +
                    '<div>taxpayerType: IP</div>' +
                    '<div>name: <Наименование ИП></div>',
                resultExample:
`{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "IP",
            "fullName": "string or null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`
            },
            {
                paramsTitle: 'Юридическое лицо:',
                params: '<div>taxpayerCode: <БИН></div>' +
                    '<div>taxpayerType: UL & UL_NR</div>' +
                    '<div>name: <Наименование организации></div>',
                resultExample:
`{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "UL",
            "fullName": "null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`
            },
            {
                paramsTitle: 'Лицо, занимающееся частной практикой:',
                params: '<div>taxpayerCode: <ИИН></div>' +
                    '<div>firstName: <Имя></div>' +
                    '<div>lastName: <Фамилия></div>' +
                    '<div>taxpayerType: LZCHP</div>',
                resultExample:
`{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "LZCHP",
            "fullName": {
                "lastName": "string",
                "firstName": "string",
                "middleName": "string"
            },
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`
            }
        ],
        FindLiquidatedTaxpayer: {
            nameServices: 'Поиск НП на стадии ликвидации:',
            link: '[portal-host]/services/isnaportalsync/public/find-liquidated-taxpayer',
            method: 'GET',
            params: '<div>date: <yyyy-mm-dd></div>' +
                '<div>taxpayerCode: <ИИН/БИН></div>' +
                '<div>name: <Наименование></div>' +
                '<div>fio: <ФИО></div>' +
                '<div>rnn: <РНН></div>' +
                '<div>periodStarts: <Период С></div>' +
                '<div>periodEnds: <Период По></div>',
            resultExample:
`{
        "ru": "string",
        "kk": "string",
        "en": "string",
        "qq": "string",
        "rnn": "string",
        "iinBin": "string",
        "firstName": "string",
        "lastName": "string",
        "middleName": "string",
        "endDate": "string",
        "beginDate": "string",
        "type": "string"
}`,
        },
        FindRiskDegreeService: {
            nameServices: localize('api-risk-degree-category', translations),
            link: '[portal-host]/services/isnaportalsync/public/find-risk-degree',
            method: 'GET',
            params:
                localize('api-print-taxpayerCode', translations) +
                '\n' +
                localize('api-print-logical', translations) +
                '\n' +
                localize('api-print-false', translations) +
                '\n' +
                localize('api-print-true', translations),
            resultExample:
`{
    "taxpayerCode" : "iinBin",
    "name" : "NP name",
    "degree" : "degreeCode",
    "relevanceDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "beginDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "endDate" : "yyyy-mm-ddT00:00:00.000+00:00"
}`,
        },
        InfoAbsenceTaxDebt: {
            nameServices: 'Cведения об отсутствии (наличии) налоговой задолженности:',
            link: '[portal-host]/services/isnaportalsync/public/tax-debt-info',
            method: 'GET',
            params: `${localize('api-print-taxpayerCode', translations)}
- rnn - РНН налогоплательщика, строковый, обязательный
- print - логический, обязательный:
- false - возвращать результат запроса в виде JSON
- true - возвращать результат в виде печатной формы (pdf-документ в формате base64`,
            resultExample:
`{
    "messageId": "mock-message-id",
    "sendTime": "timestamp",
    "iinBin": "iiBin",
    "nameRu": "NPnameRu",
    "nameKz": "NPnameKz",
    "totalArrear": 0.00,
    "totalTaxArrear": 0.00,
    "pensionContributionArrear": 0.00,
    "socialContributionArrear": 0.00,
    "socialHealthInsuranceArrear": 0.00,
    "taxOrgInfo": [ 
        {
            "charCode": "charCode",
            "nameRu": "nameRu",
            "nameKz": "nameKz",
            "reportAcrualDate": "yyyy-mm-ddTT00:00:00.000+00:00",
            "totalArrear": 0.00,
            "totalTaxArrear": 0.00,
            "pensionContributionArrear": 0.00,
            "socialContributionArrear": 0.00,
            "socialHealthInsuranceArrear": 0.00,
            "taxPayerInfo": [ 
                {
                    "iinBin": "iinBin",
                    "nameRu": "NPnameRu",
                    "nameKz": "NPnameKz",
                    "bccArrearsInfo": [ 
                        {
                            "bcc": "bccCode",
                            "bccNameRu": "bccNameRu",
                            "bccNameKz": "bccNameRu",
                            "taxArrear": 0.00,
                            "poenaArrear": 0.00,
                            "percentArrear": 0.00,
                            "fineArrear": 0.00,
                            "totalArrear": 0.00
                        }
                    ]
                }
            ]
        }
    ]
}`,
        },
        BankruptService: [
            {
                nameServices: 'Получения справочника типов сервисов',
                link: '[portal-host]/services/isnaportal/public/bankrupt-service/service-types',
                method: 'GET',
                resultExample:
`[
    { 
        "id": null, 
        "code": "INITIATED_LAB", //тип сервиса
        "kk": null, 
        "ru": null, 
        "en": null, 
        "qq": null, 
        "rank": null, 
        "hasChild": null 
    }
]`,
            },
            {
                nameServices: 'Получение сведений по возбужденным процедурам банкротства и реабилитации юридических лиц',
                link: '[portal-host]/services/isnaportal/public/bankrupt-service/event-data',
                method: 'POST',
                titleBody: 'Тело запроса: JSON-объект вида:',
                requestBody:
`{ 
    "iinBin": "070242417648", //ИИН/БИН должника 
    "orgIinBin": "0224242424355", //ИИН/БИН организации 
    "serviceType": "INITIATED_BANKRUPT_REHAB_FOR_LE" //Тип сервиса 
}`,
                resultExample:
`[
    { 
        "iinBin": "070240455888", //ИИН/БИН должника 
        "eventType": 1, //Код событий 
        "eventDate": "2024-12-19" //Дата событий 
    }
]`,
            },
        ],
    };
    const result = data[module];
    return Array.isArray(result) ? { services: result } : result;
};
